export const toLowerCase = <T extends string | undefined = undefined>(s: T) =>
  s?.toLowerCase() as T extends undefined ? undefined : Lowercase<T & string>;
